// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Hqhv","largestCol":"styles_largestCol__3ItBb","smallestCol":"styles_smallestCol__1KU1G"};